import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalNamespace as _GlobalNS } from '../../environments/environment';
import { GlobalService } from './../core/global.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../core/global.service";
var ManageAuctionFeesService = /** @class */ (function () {
    function ManageAuctionFeesService(_http, _global) {
        this._http = _http;
        this._global = _global;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
    }
    ManageAuctionFeesService.prototype.getAuctionFeesData = function (searchParams) {
        var api = _GlobalNS.api.auctionFees.search;
        var params = new HttpParams();
        params = params.set('clientId', searchParams.Client)
            .set('loanType', searchParams.LoanType)
            .set('typeOfSale', searchParams.TypeOfSale)
            .set('feeType', searchParams.FeeType)
            .set('feeAmount', searchParams.FeeAmount)
            .delete('clientId', '')
            .delete('loanType', '')
            .delete('typeOfSale', '')
            .delete('feeType', '')
            .delete('feeAmount', '');
        console.log(params);
        return this._http.get("" + api, { params: params });
    };
    ManageAuctionFeesService.prototype.save = function (params) {
        var api = _GlobalNS.api.auctionFees.create;
        var eqrf = this._global.find(_GlobalNS.paths.eqrf);
        return this._http.post(api + "&eqrf=" + eqrf, params, this.httpOptions);
    };
    ManageAuctionFeesService.prototype.getSelectorsData = function () {
        var api = _GlobalNS.api.auctionFees.changeLogSelectors;
        return this._http.get("" + api);
    };
    ManageAuctionFeesService.prototype.getUniqueClientID = function () {
        var api = _GlobalNS.api.auctionFees.uniqueClientId;
        return this._http.get("" + api);
    };
    ManageAuctionFeesService.prototype.update = function (params) {
        var api = _GlobalNS.api.auctionFees.update;
        var eqrf = this._global.find(_GlobalNS.paths.eqrf);
        return this._http.post(api + "&eqrf=" + eqrf, params, this.httpOptions);
    };
    ManageAuctionFeesService.prototype.delete = function (matrixIds) {
        var api = _GlobalNS.api.auctionFees.delete;
        var params = new HttpParams();
        params = params.set('AuctionFeesMatrixId', matrixIds);
        return this._http.get("" + api, { params: params });
    };
    ManageAuctionFeesService.prototype.getChangeLogSelectorsData = function () {
        var api = _GlobalNS.api.auctionFees.changeLogSelectors;
        return this._http.get("" + api);
    };
    ManageAuctionFeesService.prototype.getChangeLogData = function (changeLogParams) {
        var api = _GlobalNS.api.auctionFees.changeLog;
        var params = new HttpParams();
        params = params.set('ClientId', changeLogParams.UniqueClientID)
            .set('ChangedBy', changeLogParams.ChangedBy)
            .set('FeeType', changeLogParams.FeeType)
            .set('FeeAmount', changeLogParams.FeeAmount)
            .set('TypeOfSale', changeLogParams.TypeOfSale)
            .set('LoanType', changeLogParams.LoanType)
            .set('FromDate', changeLogParams.FromDate)
            .set('ToDate', changeLogParams.ToDate)
            .delete('ChangedBy', '')
            .delete('ClientId', '')
            .delete('FromDate', '')
            .delete('ToDate', '')
            .delete('FeeType', '')
            .delete('FeeAmount', '')
            .delete('TypeOfSale', '')
            .delete('LoanType', '');
        return this._http.get("" + api, { params: params });
    };
    ManageAuctionFeesService.ngInjectableDef = i0.defineInjectable({ factory: function ManageAuctionFeesService_Factory() { return new ManageAuctionFeesService(i0.inject(i1.HttpClient), i0.inject(i2.GlobalService)); }, token: ManageAuctionFeesService, providedIn: "root" });
    return ManageAuctionFeesService;
}());
export { ManageAuctionFeesService };
